let fallbackTitle = 'Portainer';
let title = '';

function updateTitle() {
  if (title) {
    document.title = title;
  } else {
    document.title = fallbackTitle;
  }
}

/** Sets the environment-specific title (shown while inside an environment). Pass '' to clear. */
export function setEnvironmentTitle(value: string) {
  title = value;
  updateTitle();
}

/** Sets the app-level title (shown when no environment is active, e.g. whitelabel name). */
export function setAppTitle(value: string) {
  fallbackTitle = value;
  updateTitle();
}
